export default "__VITE_ASSET__dJ$ULFcuzX43djbIEsCZPw__ 400w, __VITE_ASSET__ykb1zIozoJBMq4UvQnlhcQ__ 560w";